import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../_service/auth.service';
import { SharedService } from '../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  password_token= '';resetPasswordForm: FormGroup;submitted = false;loading=false;myrole='';userId='';password_mismatched:boolean=false;
  constructor(private formBuilder: FormBuilder, private authapi:AuthService, private sharedapi:SharedService,private router:Router, private route:ActivatedRoute) {
    this.myrole = localStorage.getItem('role');
    this.userId = localStorage.getItem('loginuserId');
    if(this.myrole && this.userId)
    {
      this.router.navigate(['/dashboard']);
    } 

    this.password_token = this.route.snapshot.paramMap.get("reset_password_token");
    let passwordPattern = "^[a-zA-Z0-9]{8,}$";
    this.resetPasswordForm = this.formBuilder.group({
      'new_password' : [null, Validators.compose([Validators.required, Validators.pattern(passwordPattern)])],
      'confirm_password' : [null, Validators.compose([Validators.required, Validators.pattern(passwordPattern)])],
    });
  }

  get f() { return this.resetPasswordForm.controls; }

  ngOnInit(): void {
  }

  async resetPassword()
  {
    this.password_mismatched = false;
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.resetPasswordForm.invalid) {
        this.loading = false;
        return;
    }
    if(this.resetPasswordForm.controls['new_password'].value != this.resetPasswordForm.controls['confirm_password'].value)
    {
      this.loading = false;
      this.password_mismatched = true;
    }
    else
    {
      this.resetPasswordForm.value.password_token= this.password_token; 
      await this.authapi.resetUserPassword(this.resetPasswordForm.value).subscribe((data:any) => {
        this.submitted = false;
        this.loading = false;
        if(data.status)
        {
          this.router.navigate(['/login']);
          this.resetPasswordForm.patchValue({
            'new_password': '',
            'confirm_password': ''
          });
        }
        this.sharedapi.presentToast(data.msg);
      }, error =>
      {
        this.sharedapi.checkError(error);
      });
    }
  }
}
